export default __webpack_public_path__ + "static/media/flower.4b37fed7.png";